

import { Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Pagination, Mousewheel } from "swiper/modules";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/mousewheel";

import "./SwiperCard.css";
import FontSpirulina from './../../font_component/spirulina_font/FontSpirulina';

const bannerData = [
  {
    id: 1,
    title: "Share Health,",
    highlight: "Earn More!!!",
    description:
      "Refer a friend to Spirulina and earn ₹15 per person. This referral benefit continues up to 5 levels, allowing earnings to flow through your network.",
    image: "/images/home/swiper_section/Group1.png",
    iconImg:"/images/home/swiper_section/logo1.png",
    bg: "#DEEDFF",
  },
  {
    id: 2,
    title: "Refer Friends & Earn With ",
    highlight: "Spirulina",
    description:
      "Refer a friend to Spirulina and earn ₹15 per person. This referral benefit continues up to 5 levels, allowing earnings to flow through your network.",
    image: "/images/home/swiper_section/Group2.png",
    iconImg:"/images/home/swiper_section/logo2.png",
    bg: "#FFF0EC",
  },
  {
    id: 3,
    title: "Share Health,",
    highlight: "Earn More!!!",
    description:
      "Refer a friend to Spirulina and earn ₹15 per person. This referral benefit continues up to 5 levels, allowing earnings to flow through your network.",
    image: "/images/home/swiper_section/Group1.png",
    iconImg:"/images/home/swiper_section/logo1.png",
    bg: "#DEEDFF",
  },
  {
    id: 4,
    title: "Refer Friends & Earn With ",
    highlight: "Spirulina",
    description:
      "Refer a friend to Spirulina and earn ₹15 per person. This referral benefit continues up to 5 levels, allowing earnings to flow through your network.",
    image: "/images/home/swiper_section/Group2.png",
    iconImg:"/images/home/swiper_section/logo2.png",
   bg: "#FFF0EC",
  },
];

export default function BannerSlider() {
  return (
    <div className="banner-section">
      <Container>
        <Swiper
          modules={[FreeMode, Pagination, Mousewheel]}
          spaceBetween={20}
          freeMode={true}
          grabCursor={true}
          mousewheel={{ forceToAxis: true }}
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 1 },
            768: { slidesPerView: 1.2 },
            992: { slidesPerView: 1.5 },
            1200: { slidesPerView: 2 },
          }}
          className="custom-swiper"
        >
          {bannerData.map((item,index) => (
            <SwiperSlide key={item.id}>
              <div
                className="banner-card"
                style={{ background: item.bg }}
              >
                <div className="banner-left">
                  <div className={`imgDiv ${index % 2 === 0 ? "blueBg" : "orangeBg"}`}>
                  <img className="iconImg" src={item.iconImg} alt="" />
                  </div>
                  <h4>
                    {item.title} <span><FontSpirulina color="#3C9734">{item.highlight}</FontSpirulina> </span>
                  </h4>
                  <p>{item.description}</p>
                </div>

                <div className="banner-right">
                  <img src={item.image} alt="banner" />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </div>
  );
}

